<template>
  <v-row dense>
    <v-col cols="12" md="6">
      <ValidationProvider name="Nombres del contacto" rules="required" v-slot="{ errors }">
        <v-text-field
          :value="value.first_name"
          @input="emit('first_name', $event)"
          label="Nombres"
          outlined dense
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="6">
      <ValidationProvider name="Apellidos del contacto" rules="required" v-slot="{ errors }">
        <v-text-field
          :value="value.last_name"
          @input="emit('last_name', $event)"
          label="Apellidos"
          outlined dense
          :error-messages="errors"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="6">
      <ValidationProvider name="Email del contacto" rules="required|email" v-slot="{ errors }">
        <v-text-field
          :value="value.email"
          @input="emit('email', $event)"
          label="Correo Electrónico"
          outlined dense
          :error-messages="errors"
          :disabled="readonlyEmail"
          :hint="readonlyEmail ? 'Sincronizado con Relbase' : ''"
          :persistent-hint="readonlyEmail"
        ></v-text-field>
      </ValidationProvider>
    </v-col>
    <v-col cols="12" md="4">
      <v-text-field
        :value="value.phone"
        @input="emit('phone', $event)"
        label="Teléfono"
        outlined dense
        placeholder="+56 9 ..."
        :disabled="readonlyPhone"
        :hint="readonlyPhone ? 'Sincronizado con Relbase' : ''"
        :persistent-hint="readonlyPhone"
      ></v-text-field>
    </v-col>
    <v-col cols="12" md="2">
      <v-text-field
        :value="value.cargo"
        @input="emit('cargo', $event)"
        label="Cargo"
        outlined dense
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ContactFormInline',
  props: {
    value: {
      type: Object,
      default: () => ({ first_name: '', last_name: '', email: '', phone: '', cargo: '' })
    },
    readonly: {
      type: Boolean,
      default: false
    },
    readonlyEmail: {
      type: Boolean,
      default: false
    },
    readonlyPhone: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emit(field, val) {
      this.$emit('input', { ...this.value, [field]: val })
    }
  }
}
</script>
